import { Box, Center } from '@mantine/core';

import { AuthHeader } from '@/components/layout';
import { ResetPasswordForm } from '@/features/auth/components/ResetPasswordForm';

export const ResetPasswordPage = () => {
  return (
    <Box mih="100dvh" style={{ backgroundColor: 'var(--color-bg-canvas)' }}>
      <AuthHeader />
      <Center px={{ base: 16, md: 24 }} py={{ base: 32, md: 80 }}>
        <ResetPasswordForm />
      </Center>
    </Box>
  );
};
